// config/api.js - Smart API configuration
const getBaseUrl = () => {
	// Check if we have an explicit environment variable
	if (process.env.REACT_APP_API_BASE_URL) {
		return process.env.REACT_APP_API_BASE_URL;
	}
	// Auto-detect based on current location
	if (process.env.NODE_ENV === 'development') {
		// Development mode - point to local backend
		return 'http://localhost:8000';
	} else {
		// Production mode - use relative path through nginx
		return '/v1';
	}
};

const getFrontendUrl = () => {
	// Check for explicit frontend URL override
	if (process.env.REACT_APP_FRONTEND_BASE_URL_PROD && process.env.NODE_ENV !== 'development') {
		return process.env.REACT_APP_FRONTEND_BASE_URL_PROD;
	}

	// In browser context, use current location
	if (typeof window !== 'undefined') {
		return `${window.location.protocol}//${window.location.host}`;
	}

	// Fallback for development/SSR
	if (process.env.NODE_ENV === 'development') {
		return 'http://localhost:3000';
	}

	// Production fallback - this shouldn't be reached in normal browser usage
	return 'https://your-domain.com';
};

const API_CONFIG = {
	BASE_URL: getBaseUrl(),
	TIMEOUT: 10000,
	IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
};

const VIZ_URL_CONFIG = {
	BASE_URL: "http://localhost:8050"
}

const FRONTEND_CONFIG = {
	BASE_URL: getFrontendUrl(),
	IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
};

// Optional: Add some debugging
if (API_CONFIG.IS_DEVELOPMENT) { 
	console.log('🔧 API Configuration:', API_CONFIG);
	console.log('🌐 Frontend Configuration:', FRONTEND_CONFIG);
}

export { API_CONFIG, VIZ_URL_CONFIG, FRONTEND_CONFIG };
export default API_CONFIG;
